const CloudLeftStart = () => {
  return (
    <div id="cloud-start-bg" className="absolute left-[-25%] top-[-5%]">
      <img src="/assets/background/cloud-start.svg" alt="Dynatech" />
    </div>
  );
};
export default CloudLeftStart;
